import script from "./chat-message.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-message.vue?vue&type=script&setup=true&lang=js"

import "./chat-message.vue?vue&type=style&index=0&id=4f6477d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6477d0"]])

export default __exports__